import { observationFresh, reminderSettings, visibleBuffSeconds, type BuffDefinition, type BuffObservation, type BuffPreferences } from './types'
import type { BuffNotice } from './reminders'
import { remainingUpperSeconds } from './reminders'

/** Explains the event gate; speech queue/player callbacks describe delivery separately. */
export class BuffReminderDiagnostics {
  private stages = new Map<string, string>()
  private generated = new Map<string, string>()
  reset(): void { this.stages.clear(); this.generated.clear() }
  update(observations: BuffObservation[], definitions: BuffDefinition[], preferences: BuffPreferences, events: BuffNotice[], at: number) {
    for (const event of events) this.generated.set(event.id, `${event.timerSource ?? 'recognition'}:${event.cycle}`)
    const changes: Record<string, unknown>[] = []
    const ids = new Set(definitions.map(item => item.id))
    for (const id of this.stages.keys()) if (!ids.has(id)) { this.stages.delete(id); this.generated.delete(id) }
    for (const definition of definitions) {
      const item = observations.find(item => item.id === definition.id), rule = reminderSettings(definition, preferences)
      const seconds = item ? remainingUpperSeconds(item, at) : null, cycle = item?.cycle ?? 0
      const cycleKey = `${item?.timerSource ?? 'recognition'}:${cycle}`
      const stage = !definition.enabled || !rule.nearing ? 'reminder-disabled'
        : !item || item.presence !== 'present' || !observationFresh(item, at) ? 'icon-unconfirmed'
        : this.generated.get(item.id) === cycleKey ? 'event-generated'
        : seconds === null ? 'number-insufficient'
        : seconds > rule.threshold ? 'threshold-waiting' : 'threshold-confirming'
      const key = `${cycleKey}:${stage}`
      if (this.stages.get(definition.id) === key) continue
      this.stages.set(definition.id, key)
      changes.push({ category: 'reminder-gate', id: definition.id, cycle, stage, at, seconds, displaySeconds: item ? visibleBuffSeconds(item, at) : null, numberHidden: item?.numberHidden,
        threshold: rule.threshold, speech: rule.speech, reason: item?.timeReason ?? item?.reason })
    }
    return changes
  }
}
